import { Button } from 'components/Button';
import Modal, { ModalProps } from 'components/Modal/Modal.component';
import { FC } from 'react';
import './RemoveInvitationModal.styles.scss';

type RemoveInvitationModalProps = {
  isRemoveInvitationLoading: boolean;
  onRemove: () => void;
} & Pick<ModalProps, 'isOpen' | 'onRequestClose'>;

const RemoveVacationModal: FC<RemoveInvitationModalProps> = (props) => {
  const { isOpen, onRequestClose, isRemoveInvitationLoading, onRemove } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className='remove-invitation-modal'
      hasCloseIcon
    >
      <div className='remove-invitation-modal__container'>
        <h3>Are you sure you want to delete the pending invitation for this admin?</h3>
        <p>
          Once confirmed, the invitation will expire. They will also be removed from the admin list.
        </p>
        <div className='remove-invitation-modal__btn-container'>
          <Button
            onClick={onRequestClose}
            type='button'
            className='remove-invitation-modal__cancel-btn'
          >
            Cancel
          </Button>
          <Button
            className='remove-invitation-modal__delete-btn'
            onClick={onRemove}
            loading={isRemoveInvitationLoading}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveVacationModal;
